/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

export const BA_IMAGES = [
  "a/ba-9471",
  "a/ba-9472",
  "a/ba-9473",
  "a/ba-9474",
  "a/ba-9475",
  "a/ba-9476",
  "a/ba-9477",
  "a/ba-9478"
]
